import React from 'react';
import { UsuarioProps } from '../../shared/types/usuarioProps';
import AutenticacaoController, {
  AUTH_TOKEN_NAME,
} from '../../controllers/AutenticacaoController';
import api from '../../services/Api';
import { AuthContext } from './AuthContext';

export const AuthProvider = ({ children }: { children: React.ReactNode }) => {
  const [currentUser, setCurrentUser] = React.useState<UsuarioProps | null>(
    null
  );
  const [showLoading, setShowLoading] = React.useState(false);
  const [loginError, setLoginError] = React.useState<string | null>(null);

  const signIn = async (login: string, senha: string): Promise<boolean> => {
    try {
      const result = await AutenticacaoController.Login({
        Login: login,
        Senha: senha,
      });

      api.defaults.headers.Authorization = `Bearer ${result.Data.AccessToken}`;
      const user = result.Data.User[0];

      setToken(result.Data.AccessToken);
      setCurrentUser({
        Ativo: user.Ativo,
        senha: '',
        usu_login: user.usu_login,
        usu_id: user.usu_id,
        usu_nome: user.usu_nome,
      });

      return true;
    } catch (error: any) {
      setLoginError(error?.response?.data?.message);
      localStorage.setItem('loginError', error?.response?.data?.message);
      return false;
    }
  };

  const logout = async () => {
    api.defaults.headers.Authorization = '';
    setToken('');
    setCurrentUser(null);
  };

  const setToken = (token: string) => {
    localStorage.setItem(AUTH_TOKEN_NAME, token);
  };

  const validateToken = async () => {
    const storagedToken = localStorage.getItem(AUTH_TOKEN_NAME);
    if (storagedToken) {
      try {
        setShowLoading(true);
        setShowLoading(false);
      } catch (error) {
        setToken('');
        setCurrentUser(null);
        setShowLoading(false);
        // window.location.href = '/'
      }
    }
  };

  return (
    <AuthContext.Provider
      value={{
        currentUser,
        signIn,
        logout,
        validateToken,
        showLoading,
        setShowLoading,
        loginError,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
